<script setup>
import { ref, reactive, watch } from 'vue';
import { useStore } from 'vuex';
import { useAlert } from 'dashboard/composables';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  pipeline: {
    type: Object,
    required: true,
  },
});

const store = useStore();

const state = reactive({
  name: '',
  description: '',
});

const isSaving = ref(false);
const nameError = ref('');

watch(
  () => props.pipeline,
  newPipeline => {
    if (newPipeline) {
      state.name = newPipeline.name || '';
      state.description = newPipeline.description || '';
    }
  },
  { immediate: true }
);

const handleSubmit = async () => {
  nameError.value = '';

  if (!state.name.trim()) {
    nameError.value = 'Nome e obrigatorio';
    return;
  }

  isSaving.value = true;
  try {
    await store.dispatch('pipelines/update', {
      accountId: store.getters.getCurrentAccountId,
      pipelineId: props.pipeline.id,
      pipeline: {
        name: state.name.trim(),
        description: state.description.trim(),
      },
    });

    useAlert('Pipeline atualizado com sucesso!');
  } catch (error) {
    useAlert('Erro ao atualizar pipeline');
  } finally {
    isSaving.value = false;
  }
};
</script>

<template>
  <div class="space-y-6">
    <div>
      <h3 class="text-lg font-bold text-n-slate-12 mb-1">
        Informacoes Basicas
      </h3>
      <p class="text-sm text-n-slate-11">
        Configure o nome e descricao do seu pipeline
      </p>
    </div>

    <form class="space-y-4 max-w-2xl" @submit.prevent="handleSubmit">
      <!-- Nome -->
      <label class="block">
        <span class="block text-sm font-medium text-n-slate-12 mb-1.5">
          Nome do Pipeline *
        </span>
        <input
          v-model="state.name"
          type="text"
          placeholder="Ex: Vendas B2B"
          class="w-full px-3 py-2.5 text-sm border rounded-lg bg-n-surface-1 hover:border-n-slate-6 focus:outline-none focus:border-n-brand transition-colors"
          :class="nameError ? 'border-n-ruby-9' : 'border-n-weak'"
          @input="nameError = ''"
        />
        <p v-if="nameError" class="mt-1 text-xs text-n-ruby-11">
          {{ nameError }}
        </p>
      </label>

      <!-- Descricao -->
      <label class="block">
        <span class="block text-sm font-medium text-n-slate-12 mb-1.5">
          Descricao
        </span>
        <textarea
          v-model="state.description"
          rows="4"
          placeholder="Descreva o objetivo deste pipeline..."
          class="w-full px-3 py-2.5 text-sm border border-n-weak rounded-lg bg-n-surface-1 hover:border-n-slate-6 focus:outline-none focus:border-n-brand transition-colors resize-none"
        />
      </label>

      <!-- Botao -->
      <div class="flex gap-2">
        <Button
          type="submit"
          variant="solid"
          :is-loading="isSaving"
          :disabled="isSaving"
        >
          Salvar Alteracoes
        </Button>
      </div>
    </form>
  </div>
</template>
